import { TransactionPerformResponse } from '../../types';

export class TrxSocket {
  private requestId: string;
  public ws: WebSocket;
  private socketOpened: boolean;
  private url: string;
  redirect?: string;
  private processTrxResponse: (ret: TransactionPerformResponse) => void;

  constructor(
    requestId: string,
    processTrxResponse: (ret: TransactionPerformResponse) => void
  ) {
    this.requestId = requestId;

    this.url = `${import.meta.env.VITE_APP_SOCKET_HOST}/transactions/purchase/${requestId}/`;

    this.ws = new WebSocket(this.url);
    this.socketOpened = false;

    this.ws.onopen = this.onOpen.bind(this);

    this.ws.onmessage = this.onMessage.bind(this);

    this.ws.onclose = this.onClose.bind(this);
    this.processTrxResponse = processTrxResponse;
  }

  onOpen() {
    this.socketOpened = true;
  }

  onClose() {
    this.socketOpened = false;
    if (this.requestId) {
      this.ws = new WebSocket(this.url);
    }
  }

  onMessage(e: { data: string }) {
    var ret = JSON.parse(e.data);
    this.processTrxResponse(ret);
  }

  // processTrxResponse(ret: { transaction: Record<string, any>; status: string; message: string; detail_url: string;}) {
  //   // var status = ret.transaction ? ret.transaction.status : ret.status;
  //   // // var transaction = ret.transaction;
  //   // if (['SUCCESS', 'FAILED'].includes(status) && window.payBtn) {
  //   //   window.payBtn.removeAttribute('data-kt-indicator');
  //   //   window.payBtn.removeAttribute('disabled');
  //   //
  //   //   var isSuccess = status === 'SUCCESS';
  //   //   var message = isSuccess ? gettext('Your payment has been successfully performed! Thank you for your trust.') : gettext('Sorry the transaction failed please check your information and try again');
  //   //   if (ret.message) {
  //   //     message = ret.message;
  //   //   }
  //   //
  //   //   const alert = {
  //   //     title: isSuccess ? gettext('Confirmation!') : gettext('Failure!'),
  //   //     text: message,
  //   //     icon: isSuccess ? 'success' : 'error',
  //   //     buttonsStyling: false,
  //   //     confirmButtonText: gettext('Ok, got it!'),
  //   //     customClass: {
  //   //       confirmButton: "btn fw-bold btn-light-primary"
  //   //     }
  //   //   };
  //   //
  //   //   if (ret.detail_url && window.detailLink) {
  //   //     window.detailLink.setAttribute('href', ret.detail_url);
  //   //     window.detailLink.classList.remove('d-none');
  //   //   }
  //   //   swal.fire(alert).then((result) => {
  //   //     if (result.isConfirmed) {
  //   //       if (isSuccess && this.redirect) {
  //   //         window.location.href = this.redirect;
  //   //       }
  //   //     }
  //   //   });
  //   //   this.ws.close();
  //   // }
  // }

  closeSocket() {
    this.socketOpened = false;
    if (this.requestId) {
      this.ws = new WebSocket(this.url);
    }
  }
}
